define('views/transfer/transfer_from_option',[
    'backbone',
    'views/_base/baseview',
    'text!views/transfer/transfer_from_option.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
		tagName  : 'li',
		className: 'transfer-from-option',
		isRender : true,
		template : _.template(Template),
		events   : {},
        initialize: function(options){
			options = options || {};

			this.account = options.account;
			this.account_content = '';
			this.parent_view = options.parent_view;

			this.setContent();

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
        },

		render: function(){

			this.$el.data('account-id', this.account.account_id).data('entity-id', this.account.entity_type_id).html(this.template());
			
			return this;
		},

		setContent: function(){

			if(this.account.entity_type_id == enums.entityTypeEnum.SpendingAccount){
                this.account_content = 'PayForward Account (' + formatBalanceCurrency(this.account.balance) + ')';
            } else if(this.account.entity_type_id == enums.entityTypeEnum.ExternalBank){
            	this.account_content = this.account.account_name;
            } else {
            	this.account_content = this.account.account_name + ' (' + formatBalanceCurrency(this.account.balance) + ')';
            }
			
		}
		
    });
});

